<template lang="pug">
v-container.View.View--Register
    template(v-if="step === 2")
      v-card
        v-card-text
          .text-center(data-cy="element_success")
            v-icon.mb-3(size="8rem" color="success") mdi-checkbox-marked-circle
            .title.mb-2 Registrazione inviata!
            p Riceverai a breve una mail per confermare il tuo account ed iniziare ad usarlo.
            p Se non trovi la mail controlla anche nella cartella dello spam.
            p Grazie!
    template(v-if="step === 1")
      v-card
        v-card-text.pt-4
          .subtitle-1.text-center Registrati per accedere a tutti i servizi
          ValidationObserver(v-slot="{ invalid, validated, passes }")
            v-form
              v-layout(wrap)
                v-flex(xs12)
                  ValidationProvider(name="Nome" rules="required" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.name" required
                      name="nome" type="text"
                      :error-messages="errors"
                      label="Nome" prepend-inner-icon="mdi-account"
                    )
                v-flex(xs12)
                  ValidationProvider(name="Cognome" rules="required" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.surname" required
                      name="cognome" type="text"
                      :error-messages="errors"
                      label="Cognome" prepend-inner-icon="mdi-account"
                    )
                v-flex(xs12)
                  ValidationProvider(name="Email" rules="required|email" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.email" required
                      name="e-mail" type="email"
                      :error-messages="errors"
                      label="Email" prepend-inner-icon="mdi-at"
                    )
                v-flex(xs12)
                  ValidationProvider(name="Telefono" rules="min:9" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.phone"
                      name="telefono" type="text"
                      :error-messages="errors"
                      label="Telefono" prepend-inner-icon="mdi-phone"
                    )
                v-flex(xs12)
                  ValidationProvider(name="Password" rules="required|min:6" v-slot="{ errors }" vid="password")
                    v-text-field(
                      v-model="form.password" required
                      name="password" type="password"
                      :error-messages="errors"
                      label="Password" prepend-inner-icon="mdi-asterisk"
                    )
                v-flex(xs12)
                  ValidationProvider(name="Conferma Password" rules="required|min:6|confirmed:password" v-slot="{ errors }")
                    v-text-field(
                      v-model="form.password_confirm" required
                      name="conferma password" type="password"
                      :error-messages="errors"
                      label="Conferma Password" prepend-inner-icon="mdi-asterisk"
                    )
                v-flex(xs12)
                  ValidationProvider(name="Privacy" rules="required" v-slot="{ errors }")
                    v-checkbox(
                      v-model="form.privacy" required
                      :error-messages="errors"
                      name="privacy"
                      :true-value="true"
                      :false-value="null"
                    )
                      template(slot="label")
                        span Acconsento al trattamento dei miei dati secondo la&nbsp;
                          a(href="https://www.ipraticocloud.com/files/shares/informativa_privacy_clienti.pdf" target="_blank" @click.stop) politica privacy
                v-flex.mb-4(xs12)
                  div(id="recaptcha-register")
                v-flex(xs12)
                  v-btn.secondary(
                    @click="passes(register)" :disabled="invalid || !validated"
                    :loading="loading" block rounded
                  ) Registrati
      v-flex(xs12)
        div.mt-2.text-center Hai già un account?
          router-link.pl-1(:to="{name: 'auth.login'}") Clicca qui
</template>

<script>
import User from "@/api/User";

export default {
  data: () => ({
    form: {
      name: "",
      surname: "",
      email: "",
      phone: "",
      password: "",
      password_confirm: "",
      privacy: null,
      marketing: null
    },

    step: 1,
    recaptchaWidget: null,
    recaptchaToken: null,
    loading: false
  }),

  created() {
    // Prevent navigation if already logged in
    if (this.$auth.check()) {
      this.$router.push({ name: "explore" });
    }
  },

  mounted() {
    this.$emit("update:title", "Registrazione");
    this.$nextTick(() => {
      this.recaptchaWidget = window.renderRecaptcha("recaptcha-register");
    });
  },

  methods: {
    async register() {
      this.getRecaptchaResponse();
      if (!this.recaptchaToken) return;

      try {
        this.loading = true;
        if (this.form.phone) {
          this.form.phones = [];
          this.form.phones.push(this.form.phone);
        }
        await User.register({
          ...this.form,
          "g-recaptcha-response": this.recaptchaToken
        });
        /* await this.$auth.login({
          username: `${getClientId()}:${this.form.email}`,
          password: this.form.password
        }) */
        // this.$router.go(-1)
        this.step = 2;
      } catch (error) {
        window.grecaptcha.reset();
        throw error;
      } finally {
        this.loading = false;
      }
    },

    getRecaptchaResponse() {
      this.recaptchaToken = window.grecaptcha.getResponse(this.recaptchaWidget);
    },

    goBack() {
      window.history.length > 0
        ? this.$router.go(-1)
        : this.$router.push({ name: "explore" });
    }
  }
};
</script>
